
import { defineComponent, onMounted, reactive, toRefs } from 'vue';
import { useRouter } from 'vue-router';
export default defineComponent({
  name: 'IframePage',
  setup() {
    const router = useRouter();
    const data = reactive({
      loading: true,
      herf: '',
      token: router.currentRoute.value.meta.token
    });
    // const iframeRef = ref<HTMLIFrameElement | null>(null);
    const onIframeLoaded = () => {
      data.loading = false;
      data.herf = `${router.currentRoute.value.meta.herf}?token=${data.token}`;
      // iframeRef.value.contentWindow?.postMessage(
      //   { type: "AUTH_TOKEN", token: data.token },
      //   data.herf // 必须替换为 iframe 的实际 origin
      // );
    };

    onMounted(() => {
    });


    return {
      ...toRefs(data),
      onIframeLoaded
    }
  }
})
